import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
} from "./useCrudResource"
import {
  getMovementTypes,
  getMovementType,
  createMovementType,
  editMovementType,
  deleteMovementType,
  getAllMovementTypes,
  getTrashedMovementTypes,
  restoreMovementType,
} from "api/movementTypesApi"
import { useDeleteResource } from "./useCrudResource"

export const MOVEMENT_TYPE_QUERY_KEY = "movement-types"

// -------------------- FETCH PAGINATED --------------------
export const useMovementTypes = (params = {}, enabled = true) => {
  return usePaginatedResource(
    MOVEMENT_TYPE_QUERY_KEY,
    getMovementTypes,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useMovementType = (id, enabled = true) => {
  return useResourceItem(MOVEMENT_TYPE_QUERY_KEY, getMovementType, id)
}

export const useMovementTypeBySlug = (slug, enabled = true) => {
  return useResourceItem(
    MOVEMENT_TYPE_QUERY_KEY,
    s => getMovementTypeBySlug(s),
    slug
  )
}

// -------------------- CREATE --------------------
export const useCreateMovementType = () => {
  return useCreateResource(createMovementType, MOVEMENT_TYPE_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditMovementType = () => {
  return useEditResource(editMovementType, MOVEMENT_TYPE_QUERY_KEY)
}

// -------------------- DELETE --------------------
export const useDeleteMovementType = () => {
  return useDeleteResource(deleteMovementType, MOVEMENT_TYPE_QUERY_KEY)
}

// -------------------- ADDITIONAL --------------------

// Get all movement types without pagination
export const useAllMovementTypes = (params = {}) => {
  return usePaginatedResource(
    MOVEMENT_TYPE_QUERY_KEY,
    getAllMovementTypes,
    { ...params, all: true },
    true
  )
}

// Get trashed movement types
export const useTrashedMovementTypes = (params = {}) => {
  return usePaginatedResource(
    MOVEMENT_TYPE_QUERY_KEY,
    getTrashedMovementTypes,
    params,
    true
  )
}

// Restore a trashed movement type
export const useRestoreMovementType = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreMovementType,
    onSuccess: (res, { id }) => {
      const restoredItem = res?.data
      if (!restoredItem) return

      // Update paginated cache
      queryClient.setQueriesData([MOVEMENT_TYPE_QUERY_KEY, "all"], old => {
        if (!old || !old.data || !Array.isArray(old.data.data)) return old
        const updated = structuredClone(old)
        updated.data.data = [restoredItem, ...updated.data.data]
        updated.data.total = (updated.data.total || 0) + 1
        return updated
      })

      // Update individual item cache
      queryClient.setQueryData([MOVEMENT_TYPE_QUERY_KEY, id], restoredItem)
    },
  })
}
